export default __webpack_public_path__ + "static/media/assignmentsIcon-filled.7a723682.svg";